function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_620",
  "data-name": "Group 620",
  transform: "translate(-1222 -104)"
}, React.createElement("g", {
  id: "Group_619",
  "data-name": "Group 619"
}, React.createElement("g", {
  id: "Rectangle_3840",
  "data-name": "Rectangle 3840",
  transform: "translate(1222 104)",
  fill: "none",
  stroke: "#949db2",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 15,
  height: 12,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 14,
  height: 11,
  fill: "none"
})), React.createElement("g", {
  id: "Rectangle_3841",
  "data-name": "Rectangle 3841",
  transform: "translate(1227 104.8)",
  fill: "#fff",
  stroke: "#949db2",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 2,
  height: 10.4,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 9.4,
  fill: "none"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/columns.86cec733.svg";
export { SvgComponent as ReactComponent };